import { alpha, Box, lighten, styled } from '@mui/material';

const ParentLayoutBox = styled(Box)(({ theme }) => ({
  flex: 1,
  height: '100%',

  '.MuiPageTitle-wrapper': {
    background:
      theme.palette.mode === 'dark'
        ? theme.colors.alpha.trueWhite[5]
        : theme.colors.alpha.white[50],
    marginBottom: `${theme.spacing(4)}`,
    boxShadow:
      theme.palette.mode === 'dark'
        ? `0 1px 0 ${alpha(
            lighten(theme.colors.primary.main, 0.7),
            0.15
          )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
        : `0px 2px 4px -3px ${alpha(
            theme.colors.alpha.black[100],
            0.1
          )}, 0px 5px 12px -4px ${alpha(theme.colors.alpha.black[100], 0.05)}`
  }
}));

const OutletBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 5,
  display: 'block',
  flex: 1,
  width: '100%',
  height: '100%',
  marginTop: `${theme.header.height}`
}));

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[100]};
        position: relative;
        z-index: 7;
        height: 100%;
        padding-bottom: 68px;
            @media (min-height: ${theme.breakpoints.values.lg}px) {
        top: ${theme.header.height};
        height: auto;
        }
`
);

const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(0)};

    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
    }
  }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(16)};
      color: ${theme.colors.alpha.black[100]};
      padding: ${theme.spacing(0, 2.5)};
      line-height: 1.4;
    }
`
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {

      .MuiListItem-root {
        padding: 1px 0;

        .MuiBadge-root {
          position: absolute;
          right: ${theme.spacing(0.2)};

          .MuiBadge-standard {
            background: ${theme.colors.primary.main};
            font-size: ${theme.typography.pxToRem(16)};
            font-weight: bold;
            text-transform: uppercase;
            color: ${theme.palette.primary.contrastText};
          }
        }
    
        .MuiButton-root {
          display: flex;
          color: ${theme.colors.alpha.black[100]};
          background-color: ${theme.colors.alpha.orange[100]};
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(1.2, 3)};
          border-radius: 0px;

          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(['color'])};

            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }

          .MuiButton-startIcon {
            color: ${theme.colors.alpha.trueWhite[30]};
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(1)};
          }
          
          .MuiButton-endIcon {
            color: ${theme.colors.alpha.trueWhite[50]};
            margin-left: auto;
            opacity: .8;
            font-size: ${theme.typography.pxToRem(20)};
          }

          &.active,
          &:hover {
            background-color: ${alpha(theme.colors.alpha.orange[70], 100)};
            color: ${theme.colors.alpha.trueWhite[100]};

            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.colors.alpha.trueWhite[100]};
            }
          }
        }

        &.Mui-children {
          flex-direction: column;

          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(7)};
          }
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiListItem-root {
            padding: 1px 0;

            .MuiButton-root {
              padding: ${theme.spacing(0.8, 3)};

              .MuiBadge-root {
                right: ${theme.spacing(3.2)};
              }

              &:before {
                content: ' ';
                background: ${theme.colors.alpha.black[50]};
                opacity: 0;
                transition: ${theme.transitions.create([
                  'transform',
                  'opacity'
                ])};
                width: 6px;
                height: 6px;
                transform: scale(0);
                transform-origin: center;
                border-radius: 20px;
                margin-right: ${theme.spacing(1.8)};
              }

              &.active,
              &:hover {

                &:before {
                  transform: scale(1);
                  opacity: 100;
                }
              }
            }
          }
        }
      }
    }
`
);

export {
  ParentLayoutBox,
  OutletBox,
  SidebarWrapper,
  MenuWrapper,
  SubMenuWrapper
};
